import { render, staticRenderFns } from "./RealName.vue?vue&type=template&id=60641d07&scoped=true"
import script from "./RealName.vue?vue&type=script&lang=js"
export * from "./RealName.vue?vue&type=script&lang=js"
import style0 from "./RealName.vue?vue&type=style&index=0&id=60641d07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60641d07",
  null
  
)

export default component.exports